import React from 'react';
import { useTranslation } from 'react-i18next';

import { SubHeading } from '../../components';
import './SpecialMenu.css';

const treatments = [
  { id: 'oil', titleKey: 'oil', textKey: 'oil_text', prices: ['60 min / € 60', '90 min / € 85', '120 min / € 120'] },
  { id: 'maithai', titleKey: 'maithai', textKey: 'maithai_text', prices: ['60 min / € 60', '90 min / € 85', '120 min / € 120'] },
  { id: 'couple', titleKey: 'couple', textKey: 'couple_text', prices: ['60 min / € 120', '90 min / € 170', '120 min / € 240'] },
  { id: 'traditional', titleKey: 'traditional', textKey: 'traditional_text', prices: ['60 min / € 60', '90 min / € 85', '120 min / € 120'] },
  { id: 'foot', titleKey: 'foot', textKey: 'foot_text', prices: ['60 min / € 50', '90 min / € 75', '120 min / € 100'] },
];

const SpecialMenu = () => {
  const { t } = useTranslation();

  return (
    <div className="app__specialMenu section--light section__padding" id="menu">
      <div className="app__container">
        <div className="section__title">
          <SubHeading title={t('relaxation')} />
          <h1 className="headtext__cormorant">{t('our_1')}</h1>
          <div className="section__title-accent" />
        </div>

        <div className="app__specialMenu-grid">
          {treatments.map((treatment) => (
            <article key={treatment.id} className="app__specialMenu-card">
              <h2 className="app__specialMenu-card_title">{t(treatment.titleKey)}</h2>
              <p className="app__specialMenu-card_text">{t(treatment.textKey)}</p>
              <div className="app__specialMenu-card_prices">
                {treatment.prices.map((price) => (
                  <span key={price} className="app__specialMenu-card_price">{price}</span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="app__specialMenu-footer">
          <a href="https://wa.me/+393713501881" target="_blank" rel="noreferrer">
            <button type="button" className="custom__button">{t('book')}</button>
          </a>
          <p className="app__specialMenu-note">{t('nb')}</p>
        </div>
      </div>
    </div>
  );
};

export default SpecialMenu;
